export enum PermissionResourceType {
    Folder = "Folder",
    Layer = "Layer",
    Map = "Map",
    MappingLibrary = "MappingLibrary",
    Project = "Project",
    Global = "Global",
    Group = "Group",
    PersonalMappingLibrary = "PersonalMappingLibrary",
    Schedule = "Schedule",
    ScheduleVersion = "ScheduleVersion",
    EventBlock = "EventBlock",
    VenueLocation = "VenueLocation"
}